// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

import { VideoFragmentDoc } from '../video.fragment.generated';
export const ComponentVideoFragmentDoc = `
    fragment componentVideo on ComponentVideo {
  video {
    ...video
  }
  videoWidth: width
}
    `;